














import Vue from 'vue';
import ProjectsSelectComponent from '@/components/Admin/Models/Filter/ProjectsSelectComponent.vue';
import TypesSelectComponent from '@/components/Admin/Models/Filter/TypesSelectComponent.vue';
import StatusSelectComponent from '@/components/Admin/Models/Filter/StatusSelectComponent.vue';
import DateFromComponent from '@/components/Admin/Models/Filter/DateFromComponent.vue';
import DateToComponent from '@/components/Admin/Models/Filter/DateToComponent.vue';
import ResetFilterButton from '@/components/Admin/Models/Filter/ResetFilterButton.vue';

export default Vue.extend({
  components: {
    ProjectsSelectComponent,
    TypesSelectComponent,
    StatusSelectComponent,
    DateFromComponent,
    DateToComponent,
    ResetFilterButton
  },
  computed: {
    showAdvancedFilter(): boolean {
      return this.$store.direct.state.Model.showAdvancedFilter;
    }
  }
});
